import { Component, OnInit, Input } from '@angular/core';
import { BcAccountClientService } from '../../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { DialogService } from 'ng2-bootstrap-modal';
import { saveAs } from 'file-saver';
import { ConfirmComponent } from '../../../../shared/confirm/confirm.component';

@Component({
	selector: 'app-bc-e-attachment',
	templateUrl: './bc-e-attachment.component.html',
	styleUrls: ['./bc-e-attachment.component.scss']
})
export class BcEAttachmentComponent implements OnInit {

	@Input("proposalID") proposalID;
	@Input("accountClientID") accountClientID;
	@Input("isView") isView;
	private proposalAttachments;
	private proposalType = 0; // 0 = Proposta Prorrogação, 1 = Proposta Abono, 2 = Proposta Juridico
	private description: string = "";
	private isLoaded: boolean = false;


	constructor(private bcAccountClientService: BcAccountClientService,
		private flashMessagesService: FlashMessagesService,
		private dialogService: DialogService) { }

	ngOnInit() {
	}

	loadAttachs() {
		if (!this.isLoaded) {
			this.getProposalAttachments();
			this.isLoaded = true;
		}
	}

	getProposalAttachments() {
		this.bcAccountClientService.getAttachmentsList(this.proposalID, this.proposalType).subscribe(result => {
			if (result.Success) {
				this.proposalAttachments = result.Result;
				console.log(this.proposalAttachments);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}


	fileSelected() {
		var input: any = document.getElementById("fileAttach");
		var file = input.files[0];
		this.uploadAttachment(file);
		input.value = null;
	}


	uploadAttachment(file) {

		this.bcAccountClientService.insertProposalAttachment(this.accountClientID, this.proposalID, this.proposalType, this.description, file).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Anexo enviado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				this.description = "";
				this.getProposalAttachments();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	downloadAttachment(index) {
		this.bcAccountClientService.downloadAttachment(this.proposalAttachments[index].ID).subscribe(blob => {
			if (blob) {
				saveAs(blob, this.proposalAttachments[index].NomeArquivo);
			} else {
				this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}


	inactivateAttachment(id) {

		this.bcAccountClientService.inactivateAttachment(id).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Anexo removido com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				this.getProposalAttachments();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	showRemoveAttachModal(id) {
		let disposable = this.dialogService.addDialog(ConfirmComponent, {
			title: 'Confirmação',
			message: 'Confirma a exclusão do anexo?',
			warning: "Essa ação não poderá ser revertida."
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				//We get dialog result
				if (isConfirmed) {
					this.inactivateAttachment(id);
				}
				else {
					//Do nothing here for now
				}
			});
	}



}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-extension-proposal/bc-e-attachment/bc-e-attachment.component.ts